import React from 'react';
import styled from 'styled-components';
import { getSeasonOptions } from '../../dashboard/utils/helpers';
import SearchInput from '../../../components/search/SearchInput';
import Select from '../../../components/ui/input/Select';
import { DOCUMENT_SORT_OPTIONS } from '../constants/constants';
import { DocumentSortOptionsEnum } from '../types/types';

const HeaderContainer = styled.header`
	display: flex;
	justify-content: end;
	align-items: center;
	gap: 10px;
	flex-wrap: wrap;
	margin-top: 20px;
	margin-bottom: 10px;
`;

const InputElement = styled.div`
	flex: 0 1 auto;

	&:nth-child(1) {
		font-size: 20px;
		color: var(--color-light-gray);
	}

	&:nth-child(2) {
		flex: 1 1 auto;
	}

	&:nth-child(4) input {
		width: 280px;
	}
`;

const Season = styled.div`
	font-size: var(--font-size-700);
	color: var(--color-deep-gray);
`;

interface DocumentHeaderProps {
	season: string;
	podcastType: string;
	seasonCount: number;
	podcastSeasons: string[];
	sortOrder: DocumentSortOptionsEnum;
	searchValue: string;
	isLoadingDocuments: boolean;
	onChangeSortOrder: (value: string | DocumentSortOptionsEnum) => void;
	onChangeSeason: (season: string) => void;
	onChangeSearchValue: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const DocumentHeader: React.FC<DocumentHeaderProps> = ({
	season,
	podcastType,
	seasonCount,
	podcastSeasons,
	sortOrder,
	searchValue,
	isLoadingDocuments,
	onChangeSortOrder,
	onChangeSeason,
	onChangeSearchValue
}) => {
	const seasonOptions = getSeasonOptions(podcastSeasons);

	return (
		<HeaderContainer>
			<InputElement>Documents</InputElement>
			<InputElement>
				{podcastType === 'serial' && (
					<>
						{seasonCount === 1 && <Season>{seasonOptions[0]?.label}</Season>}
						{seasonCount > 1 && (
							<Select
								value={season}
								onChange={(season) => onChangeSeason(season)}
								options={seasonOptions}
								placeholder="All Seasons"
								disabled={isLoadingDocuments}
							/>
						)}
					</>
				)}
			</InputElement>
			<InputElement>
				<Select
					value={sortOrder}
					onChange={onChangeSortOrder}
					options={DOCUMENT_SORT_OPTIONS}
					disabled={isLoadingDocuments}
				/>
			</InputElement>
			<InputElement>
				<SearchInput
					value={searchValue}
					onChange={onChangeSearchValue}
				/>
			</InputElement>
		</HeaderContainer>
	);
};

export default DocumentHeader;
// File renamed to src/features/documents/components/DocumentHeader.tsx
